import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { selectUserData } from '../../reducers/userDataReducer'
import './front-desk.scss'

const FrontDesk = () => {
  const { t } = useTranslation(['front-desk'])
  const userData = useSelector(selectUserData)
  const userEmail = userData?.user?.email || ''

  return (
    <div className="front-desk">
      <div className="front-desk__container">
        <iframe
          src={`https://elevateoshub.com/front-desk?email=${encodeURIComponent(userEmail)}`}
          className="front-desk__iframe"
          title={t('front-desk:title')}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  )
}

export default FrontDesk
